import * as yup from 'yup'

const schema = yup.object().shape({
  companyId: yup.number().required(),
})

export default schema
